import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const COLORS_IN_ROW_NUMBER = 7

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 3px;
  border: 1px solid ${colors.secondary70};
  height: 72px;
  width: 304px;
  padding: 4px 4px 4px 7px;
  box-sizing: border-box;
  background: #FFFFFF;
`

const SelectedColor = styled.div`
  width: 56px;
  height: 56px;
  background: ${props => props.color};
`

const Separator = styled.div`
  width: 8px;
  height: 56px;
  border-right: 1px solid ${colors.secondary90};
  margin-right: 4px;
`

const ColorBoxesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex: 1;
  height: 100%;
  align-content: space-between;
`

const ColorBox = styled.div`
  display: flex;
  border-radius: 1px;
  width: 24px;
  height: 24px;
  margin: 2px;
  background: ${props => props.color};
  cursor: pointer;
  border: 1px solid #FFFFFF;
  outline: 1px solid ${props => props.selected ? colors.primary40 : 'transparent'};
  box-sizing: content-box;

  &:hover {
    outline: 1px solid ${colors.primary40};
  }
`

const movesMap = {
  ArrowLeft: -1,
  ArrowRight: 1,
  ArrowUp: -COLORS_IN_ROW_NUMBER,
  ArrowDown: COLORS_IN_ROW_NUMBER,
}

const ColorPicker = ({ value, onChange, className, colorset }) => {
  const valueIndex = colorset.indexOf(value)
  const colorsNumber = colorset.length

  const onKeyDown = (e) => {
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
      let newValueIndex = 0
      if (valueIndex >= 0) {
        newValueIndex = (valueIndex + movesMap[e.key] + colorsNumber) % colorsNumber
      }
      onChange(colorset[newValueIndex])
      e.preventDefault()
    }
  }

  value = value.replace(/[^a-z0-9#]/gi, '')
  return (
    <StyledWrapper className={className} tabIndex='0' onKeyDown={onKeyDown} data-test='color-picker'>
      <SelectedColor color={value} data-test='color-picker-selected' />
      <Separator />
      <ColorBoxesWrapper data-test='color-picker-boxes'>
        {colorset.map(c => {
          return (
            <ColorBox
              key={c}
              color={c}
              onClick={() => onChange(c)}
              selected={c === value}
            />
          )
        })}
      </ColorBoxesWrapper>
    </StyledWrapper>
  )
}

ColorPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  colorset: PropTypes.array.isRequired,
}

export default ColorPicker
